module.exports = __webpack_public_path__ + "media/vraag_2_vraag.59539288.mp3";